var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import Input from '../input.js';
import { useField } from 'formik';
import { isValidEmail } from '@navinc/utils';
const createEmailValidator = ({ isRequired = false, requiredErrorMessage = 'Required', invalidErrorMessage = 'Please enter a valid email address', } = {}) => (address) => {
    if (isRequired && !address) {
        return [requiredErrorMessage];
    }
    if (address && !isValidEmail(address)) {
        return [invalidErrorMessage];
    }
};
export const EmailInput = (_a) => {
    var { name, onBlur, onChange, invalidOnTouched = true, isRequired, requiredErrorMessage, invalidErrorMessage } = _a, props = __rest(_a, ["name", "onBlur", "onChange", "invalidOnTouched", "isRequired", "requiredErrorMessage", "invalidErrorMessage"]);
    const memoizedValidateEmail = useMemo(() => createEmailValidator({ isRequired, requiredErrorMessage, invalidErrorMessage }), [isRequired, requiredErrorMessage, invalidErrorMessage]);
    const [field, meta] = useField({ name, validate: memoizedValidateEmail });
    return (_jsx(Input, Object.assign({ type: "email", name: name, value: field.value, onChange: (e) => {
            field.onChange(e);
            onChange && onChange(e);
        }, onBlur: (e) => {
            field.onBlur(e);
            onBlur && onBlur(e);
        }, errors: (!invalidOnTouched || meta.touched) && meta.error, isInvalid: (!invalidOnTouched || meta.touched) && !!meta.error, hasSpaceForErrors: true }, props)));
};
//# sourceMappingURL=email-input.js.map